var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("p", [
          _vm._v("Заявка: "),
          _c("strong", [_vm._v(_vm._s(_vm.data.order.id))]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Клиент: "),
          _c("strong", [
            _vm._v(_vm._s(_vm.data.order.client_name || "Не указан")),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Телефоны:")]),
        _vm._v(" "),
        _vm._l(_vm.data.order.order_phones, function (phone) {
          return _c(
            "div",
            { staticClass: "flex" },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v(_vm._s(_vm.mixinPrintPhone(phone.phone.phone))),
              ]),
              _vm._v(" "),
              _c("MakeCall", {
                attrs: {
                  order: _vm.data.order,
                  phone: { phone: phone.phone.phone, valid: true },
                },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("p", [_vm._v("Адрес: " + _vm._s(_vm.data.order.address))]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            _vm._l(_vm.data.order.details, function (drug) {
              return _c("p", [
                _vm._v("\n          " + _vm._s(drug.new_drug.title) + " * "),
                _c("strong", [_vm._v(_vm._s(drug.qty))]),
                _vm._v(" * "),
                _c("strong", [_vm._v(_vm._s(drug.price))]),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Дата планируемой доставки"),
                ]),
                _vm._v(" "),
                _c("OrderDateSelect", {
                  ref: "selectedDate",
                  attrs: {
                    disabled: true,
                    onSelect: (date) => (_vm.data.order.delivery_date = date),
                    selectedDate: _vm.data.order.delivery_date,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }